"use client";

import { createContext, useEffect, useMemo } from "react";
import { getLanguageDirection, type Language } from "@/lib/i18n";
import type { SiteTranslations } from "@/lib/translations";

export type I18nContextValue = {
    lang: Language;
    messages: SiteTranslations;
};

export const I18nContext = createContext<I18nContextValue | null>(null);

export function I18nProvider({
    lang,
    messages,
    children,
}: {
    lang: Language;
    messages: SiteTranslations;
    children: React.ReactNode;
}) {
    const value = useMemo(() => ({ lang, messages }), [lang, messages]);

    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = getLanguageDirection(lang);
    }, [lang]);

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
